<template><div><h1 id="hat-bestandteile" tabindex="-1"><a class="header-anchor" href="#hat-bestandteile"><span>Hat Bestandteile</span></a></h1>
<p>Hat Bestandteile — Bestandteile einer Stückliste</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Artikel können aus verschiedenen Bestandteilen zusammengesetzt werden. Dabei ist es unerheblich, ob der Artikel bereits in assemblierter Form vorliegt (Normalartikel Typ N mit Stückliste), oder ob er erst beim Packen assembliert (zusammengestellt) wird, also ein sogenannter Assemblierter Artikel mit Typ A ist. Eine Stückliste kann immer aus zwei verschiedenen Blickwinkeln betrachtet werden: Ein Artikel hat Bestandteile, oder er ist ein Bestandteil einer Stückliste. Diese beiden Sichtweisen sind auch im Umfeldmenü repräsentiert: &quot;hat Bestandteile&quot; bzw. &quot;ist Bestandteil von&quot;.</p>
<p>Pfad: <code v-pre>Logistik → Artikel</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Menge</dt>
<dd>Anzahl Artikel. Es ist eine Erfassung mit Komma-Stellen möglich (z.B. für zusätzliche Couverts bei Flachhkarten).</dd>
<dt>Einheit</dt>
<dd>Einheit aus <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikelstamm</a></dd>
<dt>Artikelnummer</dt>
<dd>Artikel gem <a class="link" href="ft.refdata.artikel.html" title="Artikel">Artikelstamm</a></dd>
<dt>Artikelbezeichnung</dt>
<dd>Anzeige Artikelbezeichnung</dd>
<dt>verfügbar</dt>
<dd>Summe der verfügbaren Artikel an allen Lagern</dd>
<dt>Rundung</dt>
<dd>Die Rundung kommt nur zum Tragen wenn Artikelmengen mit Nachkommastellen eingetragen werden. Folgende Rundungsregeln stehen zur Auswahl:
<table>
<thead>
<tr>
<th>Rundung</th>
<th>Beschreibung</th>
</tr>
</thead>
<tbody>
<tr>
<td>immer aufrunden</td>
<td>alle Nachkommastellen werden aufgerundet</td>
</tr>
<tr>
<td>immer abrunden</td>
<td>alle Nackommastellen werden abgerundet</td>
</tr>
<tr>
<td>&lt; 0.5 abrunden</td>
<td>&lt; 0.5 wird abgerundet, &gt;= 0.5 wird aufgerundet</td>
</tr>
<tr>
<td>&gt; 0.5 aufrunden</td>
<td>&gt; 0.5 wird aufgerundet, &lt;= 0.5 wird abgerundet</td>
</tr>
</tbody>
</table>
</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.artikel.html" title="Artikel">Artikel</RouteLink></p>
</div></template>


